var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 25.2409C7.8335 25.2409 11.7502 29.1579 15.6668 25.2409C19.583 21.3244 23.4991 25.2398 23.5002 25.2409C23.5002 25.2409 23.5001 25.2409 23.5002 25.2409C23.5012 25.242 27.4174 29.1568 31.3335 25.2409C35.2502 21.3245 39.1668 25.2409 39.1668 25.2409",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 31.1159C7.8335 31.1159 11.7502 35.0329 15.6668 31.1159C19.583 27.1994 23.4991 31.1148 23.5002 31.1159C23.5002 31.1159 23.5001 31.1159 23.5002 31.1159C23.5012 31.117 27.4174 35.0318 31.3335 31.1159C35.2502 27.1995 39.1668 31.1159 39.1668 31.1159",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 36.9909C7.8335 36.9909 11.7502 40.9079 15.6668 36.9909C19.583 33.0744 23.4991 36.9898 23.5002 36.9909C23.5002 36.9909 23.5001 36.9909 23.5002 36.9909C23.5012 36.992 27.4174 40.9068 31.3335 36.9909C35.2502 33.0745 39.1668 36.9909 39.1668 36.9909",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6462 24.4795V11.7503C16.6462 9.46562 15.2753 5.48368 9.79199 7.83368",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3127 24.4795V11.7503C32.3127 9.46562 30.9418 5.48368 25.4585 7.83368",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.646 19.5834H32.3127",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.646 15.6664H32.3127",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/Swimming.540cd5866bca8494e3902f4a9db3e848.svg";
export { ForwardRef as ReactComponent };